import { createAsyncThunk } from "@reduxjs/toolkit";
import indexAPI from "./nasdaqIndexAPI";

// Fetch all indices
export const fetchIndices = createAsyncThunk(
  "indices/fetchIndices",
  async ({ skip = 0, limit = 100 } = {}, thunkAPI) => {
    try {
      return await indexAPI.fetchIndices(skip, limit);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch index details
export const fetchIndexDetails = createAsyncThunk(
  "indices/fetchIndexDetails",
  async (ticker, thunkAPI) => {
    try {
      return await indexAPI.fetchIndexDetails(ticker);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch index prices
export const fetchIndexPrices = createAsyncThunk(
  "indices/fetchIndexPrices",
  async ({ ticker, limit = 30, skip = 0 }, thunkAPI) => {
    try {
      return await indexAPI.fetchIndexPrices(ticker, { limit, skip });
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Fetch index metrics
export const fetchIndexMetrics = createAsyncThunk(
  "indices/fetchIndexMetrics",
  async (ticker, thunkAPI) => {
    try {
      return await indexAPI.fetchIndexMetrics(ticker);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Manual refresh
export const refreshIndexPrices = createAsyncThunk(
  "indices/refreshIndexPrices",
  async ({ ticker, days = 30 }, thunkAPI) => {
    try {
      return await indexAPI.refreshIndexPrices(ticker, days);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
